// extracted by mini-css-extract-plugin
export default {"melodyVideo":"YR-z","isFullWidth":"ZR-z","landingPageVideo":"_R-z","play":"aS-z","iframeVideo":"bS-z","playHidden":"cS-z","fullwidth":"dS-z"};